export const GET_YESTERDAY_MACHINES_SHIFTS_REQUEST =
  'GET_YESTERDAY_MACHINES_SHIFTS_REQUEST';
export const GET_YESTERDAY_MACHINES_SHIFTS_SUCCESS =
  'GET_YESTERDAY_MACHINES_SHIFTS_SUCCESS';
export const GET_YESTERDAY_MACHINES_SHIFTS_ERROR =
  'GET_YESTERDAY_MACHINES_SHIFTS_ERROR';
